import React from 'react';
import {NavLink} from 'react-router-dom';
import './styles.css';

export const ErrorPage = () => {
  return (
    <section className="container mt-5">
      <div className="error"><span>404</span> content not available <br/>
        <NavLink className="nav-link" exact activeClassName="active" to="/"> Return to Home</NavLink>
      </div>

    </section>
  );
};



// WEBPACK FOOTER //
// ./src/components/common/ErrorPage.js